import { render } from "./CreateExamBlanc.vue?vue&type=template&id=53c986d5&scoped=true"
import script from "./CreateExamBlanc.vue?vue&type=script&lang=js"
export * from "./CreateExamBlanc.vue?vue&type=script&lang=js"

import "./CreateExamBlanc.vue?vue&type=style&index=0&id=53c986d5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c986d5"]])

export default __exports__